/**
 * Created by mateimisarca on 05/03/2018
 */

import InputField from './inputfield';

export default InputField;
